import {AxiosError} from 'axios';
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';
import type {Participant} from '@eksab/features/competition/types';

type RankingPage = {
  data?: Participant[];
  meta?: {
    current_page: number;
    last_page: number;
    from: number;
    to: number;
    per_page: number;
    total: number;
  };
};

const queryKey = (groupID: string) => ['group-ranking', groupID];

const queryFn = (groupID: string, page = 1) =>
  api.get<RankingPage>(`rankings?group-id=${groupID}&page=${page}`).then((res) => res.data);

export const useParticipantsRankingsQuery = (
  groupID: string,
  options?: UseInfiniteQueryOptions<RankingPage, AxiosError>,
) =>
  useInfiniteQuery<RankingPage, AxiosError>(queryKey(groupID), ({pageParam}) => queryFn(groupID, pageParam), {
    ...options,
    enabled: !!groupID && (options?.enabled ?? true),
    getNextPageParam: ({meta}) => (meta && meta.current_page < meta.last_page ? meta.current_page + 1 : undefined),
  });

useParticipantsRankingsQuery.queryFn = queryFn;
useParticipantsRankingsQuery.queryKey = queryKey;
